import { BusinessPurpose } from '@/modules/asset/enums/BusinessPurpose';
import { BusinessStructure } from '@/modules/asset/enums/BusinessStructure';

export class PrivateStockAssetMeta {
  issuedBy?: string;

  purpose?: string;

  legalStructure?: string;

  ownershipPercentage?: number;

  valueOfBusiness?: number;

  valueOfBusinessAtMarriage?: number;

  valuationType?: string;

  vestedStockCount?: number;

  valuePerShare?: number;

  strikePricePerShare?: number;

  /**
   * @deprecated
   */
  type?: string;

  /**
   * @deprecated
   */
  valuePerShareAtMarriage?: number;

  constructor(model: Partial<PrivateStockAssetMeta> = {}) {
    this.issuedBy = model.issuedBy;
    this.purpose = model.purpose;
    this.legalStructure = model.legalStructure;
    this.ownershipPercentage = model.ownershipPercentage;
    this.valueOfBusiness = model.valueOfBusiness;
    this.valueOfBusinessAtMarriage = model.valueOfBusinessAtMarriage;

    this.valuationType = model.valuationType;
    this.valuePerShare = model.valuePerShare;
    this.strikePricePerShare = model.strikePricePerShare;
    this.vestedStockCount = model.vestedStockCount;

    this.type = model.type;
    this.valuePerShareAtMarriage = model.valuePerShareAtMarriage;
  }

  get title(): string {
    return this.issuedBy;
  }

  get purposeValue(): string | undefined {
    return BusinessPurpose.getByKey(this.purpose)?.displayValue ?? '';
  }

  get legalStructureValue(): string | undefined {
    return BusinessStructure.getByKey(this.legalStructure)?.value ?? '';
  }
}
